<template>
  <v-col class="register default-slot" md="7" sm="12">
    <v-dialog v-model="dialog" width="500px">
      <v-card class="confirmation-modal">
        <v-img
          class="modal-icon"
          width="84"
          :src="thumbsUpImage"
        />
        <h2 class="mt-8 mb-8">
          Thank you, your {{renewal ? 'renew' : 'register' }} affiliate request has been submitted. You will
          be notified of approval.
        </h2>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogError" width="500px">
      <v-card class="confirmation-modal">
        <h2 class="mt-8 mb-8">
          {{ errorMessage }}
        </h2>
      </v-card>
    </v-dialog>
    <div class="top-icons">
      <a
        class="back-icon"
        v-on:click="changePage(2);"
      >
        <font-awesome-icon icon="long-arrow-alt-left" size="lg" /> Back
      </a>
    </div>
    <h1 class="register-title mb-3">{{title}}</h1>
    <v-form class="register-form" v-model="isValid">
      <div class="table-gray-box">
        <table>
          <tr>
            <td>{{renewal ? 'Renew' : 'Register' }} Affiliate</td>
            <td>${{ fee }}</td>
            <v-tooltip bottom content-class="fee-table-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on"
                  ><font-awesome-icon icon="info-circle"
                /></span>
              </template>
              <simple-fee-table :priceInfo="feeInfo" excludeService />
            </v-tooltip>
          </tr>
          <tr>
            <td>Total</td>
            <td>${{ fee }}</td>
          </tr>
        </table>
      </div>
      <signature class="mt-3" :signature="signature" v-on:update="signature = $event">
        <!-- TODO: what is the signature text for this process? -->
        <template v-slot:signatureText>
          <affiliate-signature-text />
        </template>
      </signature>
    </v-form>
    <v-overlay :value="processingRequest">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <hosted-registration-payment
      :disabled="!isValid || signature === '' || processingRequest || fee === null"
      buttonText="SUBMIT"
      v-on:updatePaymentInfo="($event) => {
        processingRequest = true;
        submitRequest($event, signature);
      }"
    />
    <p class="steps">STEP <b>3</b> OF <b>3</b></p>
    <footer-text />
  </v-col>
</template>

<script lang="ts">
import Vue from "vue";

import HostedRegistrationPayment from "@/components/common/HostedRegistrationPayment.vue";
import Signature from "@/components/common/inputs/Signature.vue";
import SimpleFeeTable from "@/components/common/SimpleFeeTable.vue";
import FooterText from "@/components/common/FooterText.vue";
import AffiliateSignatureText from "@/components/common/AffiliateSignatureText.vue";

import { UserInfo } from "@/types/User";
import { getErrorMessage } from "@/services/errorHandler";

const thumbsUpImage = require('@/assets/thumbs-up-duotone.svg');

export default Vue.extend({
  name: "AffiliatePayment",
  components: {
    HostedRegistrationPayment,
    Signature,
    SimpleFeeTable,
    FooterText,
    AffiliateSignatureText,
  },
  props: {
    title: String,
    renewal: Boolean,
    changePage: Function,
    status: Object,
    submitRequest: Function,
    fee: Number,
    feeInfo: Object,
  },
  data: function () {
    return {
      thumbsUpImage,
      dialog: false,
      dialogError: false,
      signature: "",
      processingRequest: false,
      isValid: true,
      errorMessage: "",
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
  methods: {
    openModal: function () {
      this.$data.dialog = true;
    },
    openErrorModal: function () {
      this.$data.dialogError = true;
    },
  },
  watch: {
    status: function (newVal: any, oldVal: any) {
      if (newVal?.success) {
        this.openModal();      
      } else {
        this.errorMessage = getErrorMessage(newVal);
        this.openErrorModal();
      }
    },
    dialog: function (newVal: boolean, oldVal: boolean) {
      if (!newVal) {
        this.$store.dispatch("loadPersonTasks");
        this.$navigate("/");
      }
    },
    dialogError: function (newVal: boolean, oldVal: boolean) {      
      if (!newVal && this.status?.data?.paymentIssue) {
        this.processingRequest = false;
        this.$store.dispatch("loadPersonTasks");
        this.$navigate("/");
      } else if (!newVal) {
        this.processingRequest = false;
      }
    },
  },
});
</script>
